import { apiRequest } from "../_core/apiRequest";

export async function updateProfileInfo(infoData) {
  return apiRequest({
    method: "put",
    path: "/profile/info",
    data: infoData,
    errorMessage: "Erro ao atualizar perfil",
  });
}
